export default "__VITE_ASSET__BHTXpfML__"